<template>
  <div class="container">
    <div class="row mb-0">
      <div class="col-10">
        <h3 class="h3">
          <i class="fa fa-user-plus mr-1"></i>
          Recruiting Tracker
          <span class="badge badge-danger">
            BETA
          </span>
        </h3>
      </div>
      <div class="col-2 text-right">
        <a class="btn btn-primary disabled" href="#">
          <i class="fa fa-cog"></i>
          <span class="ml-1 d-none d-md-inline">
            Build Plan
          </span>
        </a>
      </div>
    </div>
    <div class="row mb-4">
      <div class="col-12 text-left text-md-right">
        <small class="text-muted">Plan builder coming Spring 2018!</small>
      </div>
    </div>

    <header class="mb-4">
      <h4 class="h4">
        Today is <b>{{ today }}</b>
      </h4>
      <span v-if="hasTrackedToday">
        Great start! Way to make some progress.
      </span>
      <span v-else>
        You haven't tracked any activity yet today.
      </span>
    </header>

    <div class="row mb-4 pb-4">
      <div class="col-md-6">
        <h4 class="h4 mb-3 text-gold">
          Prospecting
        </h4>
        <activity-slider
          label="Calls Made"
          icon="fa-phone"
          class="mb-3"
          v-model="conversations_attempted"
        ></activity-slider>
        <activity-slider
          label="Conversations Had"
          icon="fa-comments"
          class="mb-3"
          v-model="conversations_held"
        ></activity-slider>
        <activity-slider
          label="Coffee Meetings Set"
          icon="fa-coffee"
          class="mb-3"
          v-model="coffee_meetings_scheduled"
        ></activity-slider>
        <activity-slider
          label="Value Prop Meetings Scheduled"
          icon="fa-dollar"
          class="mb-3"
          v-model="value_prop_meetings_scheduled"
        ></activity-slider>
      </div>
      <div class="col-md-6">
        <h4 class="h4 mb-3 text-gold">
          Presentations
        </h4>
        <activity-slider
          label="Coffee Meetings Held"
          icon="fa-coffee"
          class="mb-3"
          v-model="coffee_meetings_held"
        ></activity-slider>
        <activity-slider
          label="Value Prop Meetings Held"
          icon="fa-dollar"
          class="mb-3"
          v-model="value_prop_meetings_held"
        ></activity-slider>
        <activity-slider
          label="3rd+ Meetings Held"
          icon="fa-calendar"
          class="mb-3"
          v-model="extra_meetings_held"
        ></activity-slider>
        <activity-slider
          label="Agents Hired"
          icon="fa-user-plus"
          class="mb-3"
          v-model="hired"
        ></activity-slider>
      </div>
    </div>

    <!--
    <div class="pb-5">
      <h3 class="h4 text-center mb-5">
        <i class="fa fa-bar-chart mr-1"></i>
        Recruiting Stats
      </h3>

      <div class="row">
        <div class="col-md-6 mb-3">
          <div class="card">
            <div class="card-body py-4 px-0">
              <div class="d-flex justify-content-center align-items-center mb-3">
                <span class="profile-img tiny mr-2" style="background-image:url('https://www.gravatar.com/avatar/948b7915afdc9fde88c0de73f77129f4')">
                  <span class="profile-img-body" />
                </span>
                <span>
                  Aaron Collegeman
                </span>
              </div>
              <stats-graph :height="175" :chart-data="{
                labels: [
                  'Conversations',
                  'Coffee Mtgs',
                  'Value Prop Mtgs',
                  '3rd+ Mtgs',
                  'Hires'
                ],
                datasets: [{
                  label: 'Conversion Target',
                  data: [15, 5, 3, 0, 10],
                  borderColor: '#000000',
                  type: 'line',
                  icons: [
                    '',
                    '',
                    '',
                    '',
                    ''
                  ]
                }, {
                  label: 'Setup Targets',
                  data: [-15, -5, -3, null, null],
                  borderColor: '#000000',
                  type: 'line',
                  icons: [
                    '',
                    '',
                    '',
                    '',
                    ''
                  ]
                }, {
                  label: 'Setup',
                  data: [-20, -16, -12, null, null],
                  backgroundColor: '#404041',
                  icons: [
                    '',
                    '',
                    '',
                    '',
                    '',
                  ]
                }, {
                  label: 'Conversion',
                  data: [10, 8, 6, 4, 2],
                  backgroundColor: '#bcb08a',
                  icons: [
                    '\uf075',
                    '\uf0f4',
                    '\uf155',
                    '\uf073',
                    '\uf234',
                  ]
                }]
              }"/>
            </div>
          </div>

        </div>

      </div>

    </div>
    -->
    
  </div>
</template>

<style lang="scss">

</style>

<script>
import { merge } from 'lodash'
import wait from '@/lib/wait'
import ActivitySlider from '@/components/business-plan-editor/ActivitySlider'
import { logRecruitingActivity } from '@/api'
import moment from 'moment'
import { Bar, mixins } from 'vue-chartjs'
const { reactiveProp } = mixins

export default {
  components: {
    ActivitySlider,
    'StatsGraph': {
      extends: Bar,
      mixins: [ reactiveProp ],
      props: [ 'chartData', 'options' ],
      mounted () {
        this.renderChart(this.chartData, merge(this.options || {}, {
          plugins: {
            datalabels: {
              align: 'end',
              anchor: 'end',
              color: '#404041',
              font: {
                family: 'FontAwesome',
                size: 20
              },
              formatter: function (value, context) {
                return context.dataset.icons[context.dataIndex]
              }
            }
          },
          scales: {
            xAxes: [{
              stacked: true
            }],
            yAxes: [{
              stacked: true,
              display: false
            }]
          },
          legend: false,
          tooltips: false,
          layout: {
            padding: {
              top: 30,
              left: 0,
              right: 0,
              bottom: 0
            }
          }
        }))
      }
    }
  },
  props: {
    activity: {
      type: Object,
      default () {
        return {
          conversations_attempted: 0,
          conversations_held: 0,
          coffee_meetings_scheduled: 0,
          coffee_meetings_held: 0,
          value_prop_meetings_scheduled: 0,
          value_prop_meetings_held: 0,
          extra_meetings_scheduled: 0,
          extra_meetings_held: 0,
          hired: 0
        }
      }
    }
  },
  data () {
    return {
      conversations_attempted: this.activity.conversations_attempted,
      conversations_held: this.activity.conversations_held,
      coffee_meetings_scheduled: this.activity.coffee_meetings_scheduled,
      coffee_meetings_held: this.activity.coffee_meetings_held,
      value_prop_meetings_scheduled: this.activity.value_prop_meetings_scheduled,
      value_prop_meetings_held: this.activity.value_prop_meetings_held,
      extra_meetings_scheduled: this.activity.extra_meetings_scheduled,
      extra_meetings_held: this.activity.extra_meetings_held,
      hired: this.activity.hired
    }
  },
  computed: {
    today () {
      return moment().format('MMMM D')
    },
    hasTrackedToday () {
      return this.conversations_attempted + this.conversations_held + this.coffee_meetings_scheduled + this.coffee_meetings_held + this.value_prop_meetings_scheduled + this.value_prop_meetings_held + this.extra_meetings_scheduled + this.extra_meetings_held + this.hired > 0
    }
  },
  watch: {
    conversations_attempted () {
      this.log('conversations_attempted', this.conversations_attempted)
    },
    conversations_held () {
      this.log('conversations_held', this.conversations_held)
    },
    coffee_meetings_scheduled () {
      this.log('coffee_meetings_scheduled', this.coffee_meetings_scheduled)
    },
    coffee_meetings_held () {
      this.log('coffee_meetings_held', this.coffee_meetings_held)
    },
    value_prop_meetings_scheduled () {
      this.log('value_prop_meetings_scheduled', this.value_prop_meetings_scheduled)
    },
    value_prop_meetings_held () {
      this.log('value_prop_meetings_held', this.value_prop_meetings_held)
    },
    extra_meetings_scheduled () {
      this.log('extra_meetings_scheduled', this.extra_meetings_scheduled)
    },
    extra_meetings_held () {
      this.log('extra_meetings_held', this.extra_meetings_held)
    },
    hired () {
      this.log('hired', this.hired)
    }
  },
  methods: {
    log: (field, count) => {
      wait.saving()
      return logRecruitingActivity(field, count)
        .then((response) => {
          wait.saved()
        })
        .catch((response) => {
          wait.oops()
        })
    }
  }
}
</script>
